import { render, staticRenderFns } from "./AlbumPlaylistMobile.vue?vue&type=template&id=0a5abcd0&scoped=true"
import script from "./AlbumPlaylistMobile.vue?vue&type=script&lang=js"
export * from "./AlbumPlaylistMobile.vue?vue&type=script&lang=js"
import style0 from "./AlbumPlaylistMobile.vue?vue&type=style&index=0&id=0a5abcd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5abcd0",
  null
  
)

export default component.exports